import React, { useEffect } from "react";
import Dashboard from "./Dashboard";

export default function View(props) {
	const { loginUser, loginLoading } = props;

	useEffect(() => {
		loginUser();
	}, []);

	if (loginLoading) {
		return (
			<div
				style={{
					minHeight: "100vh",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}>
				<span
					className="loadingSpinner"
					style={{
						display: "block",
						position: "static",
						border: "4px solid #3d5265",
						borderRightColor: "transparent",
						margin: 0,
					}}
				/>
			</div>
		);
	}

	return <Dashboard props={props} />;
}
